import "./Redes.css";

import { Link } from "react-router-dom";

const Redes = () => {
  return (
    <div className="redes_container">
      <h2>Minhas Redes Sociais</h2>
      <span>Clique em cima dos nomes para ser redirecionado</span>
      <p className="alert_values">
        Ao entrar em contato ou realizar alguma compra, você esta ciente e
        concorda com&nbsp;
        <Link to="/termos" style={{ color: "red" }}>
          Termos de Uso
        </Link>
        .
      </p>
      <p className="alert_values">
        veja também &nbsp;
        <Link to="/como_funciona" style={{ color: "red" }}>
          Como funciona?
        </Link>
        .
      </p>
      <div
        className="redes_content"
        onClick={() => window.open("https://www.instagram.com/di_developer/")}
      >
        <i className="bi bi-instagram"></i>
        <span>Instagram</span>
      </div>
      <div
        className="redes_content"
        onClick={() => window.open("https://t.me/Rpvsuporte")}
      >
        <i className="bi bi-telegram"></i>
        <span>Telegram</span>
      </div>
      <div
        className="redes_content"
        onClick={() => window.open("https://www.tiktok.com/@dideveloper")}
      >
        <i className="bi bi-tiktok"></i>
        <span>TikTok</span>
      </div>
    </div>
  );
};

export default Redes;
